var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2681_2973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.01882 11.0833C7.24871 11.0837 7.47642 11.0387 7.68885 10.9508C7.90128 10.8629 8.09424 10.7339 8.25665 10.5712L10.5427 8.28333L9.7179 7.46083L7.59865 9.58067L7.58348 0H6.41682L6.43198 9.57133L4.32032 7.45967L3.49548 8.28333L5.78157 10.5694C5.94378 10.7323 6.13659 10.8616 6.34892 10.9498C6.56124 11.038 6.7889 11.0834 7.01882 11.0833Z",
    fill: "#202124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 9.33301V12.2497C12.8333 12.4044 12.7719 12.5528 12.6625 12.6621C12.5531 12.7715 12.4047 12.833 12.25 12.833H1.75C1.59529 12.833 1.44692 12.7715 1.33752 12.6621C1.22812 12.5528 1.16667 12.4044 1.16667 12.2497V9.33301H0V12.2497C0 12.7138 0.184374 13.1589 0.512563 13.4871C0.840752 13.8153 1.28587 13.9997 1.75 13.9997H12.25C12.7141 13.9997 13.1592 13.8153 13.4874 13.4871C13.8156 13.1589 14 12.7138 14 12.2497V9.33301H12.8333Z",
    fill: "#202124"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2681_2973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.5da4b3b4fb4f2b6cea59a4caa78d8ab5.svg";
export { ForwardRef as ReactComponent };